import { IGeoAddressSchema } from '../../../node/repositories/countryside-search/entities/geo/GeoAddressSchema';

export const getFBGeo = (geos: IGeoAddressSchema) => {
  if (!geos.details) {
    return [];
  }

  return geos.details.filter(item => item.type === 'location').map(item => item.fullName);
};
